export default __webpack_public_path__ + "static/sami@2x-6f2084048952707900def32f7c65ae98.jpg";